import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const OnScreenInstructions = ({ instruction, }) => {
    return (_jsx("div", { className: "fixed left-1/2 transform -translate-x-1/2 top-4 z-40 px-4 py-2 rounded-lg backdrop-blur-sm", style: {
            backgroundColor: 'rgba(38, 50, 56, 0.85)',
            color: 'var(--sand)',
            border: '1px solid var(--pewter)'
        }, children: _jsx("span", { className: "text-sm", children: instruction }) }));
};
